import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Country, I18nModule, UserAddressService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormErrorsModule } from '@spartacus/storefront';
import { CountriesDropdownComponent } from '../../../../../components/form-elements/countries-dropdown/countries-dropdown.component';
import { FormModule } from '@spartacus/organization/administration/components';
import { DragAndDropComponent } from '../../../../../components/drag-and-drop/drag-and-drop.component';
import { DragAndDropReport } from '../../../../../components/drag-and-drop/core/drag-and-drop.model';
import { QuotesService } from '../../core/quotes.service';

@Component({
  selector: 'general-information',
  standalone: true,
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    FormModule,
    FormErrorsModule,
    CountriesDropdownComponent,
    DragAndDropComponent,
  ],
  templateUrl: './general-information.component.html',
  styleUrl: './general-information.component.scss',
})
export class GeneralInformationsComponent implements OnInit, OnDestroy {
  @Input() form!: FormGroup;
  @Output() getGeneralForm = new EventEmitter();

  country?: Country;
  subscription = new Subscription();
  clearFiles$ = this.quotesService.clearFileList$;
  resetGeneralInformation$ = this.quotesService.resetGeneralInformation$;
  countries$ = this.userAddressService.getDeliveryCountries();

  constructor(
    private userAddressService: UserAddressService,
    private cdr: ChangeDetectorRef,
    private quotesService: QuotesService,
  ) {}

  ngOnInit(): void {
    this.userAddressService.loadDeliveryCountries();
    this.listners();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  listners() {
    this.subscription.add(
      this.resetGeneralInformation$.subscribe(() => {
        this.setCountry();
      }),
    );
  }

  setFiles(dragReport: DragAndDropReport): void {
    const ctrlAttachment = this.form.get('additionalAttachment')!;
    const files = dragReport.items?.map(item => item.file) || [];
    ctrlAttachment.setValue(files);
  }

  setCountry(country?: Country) {
    const isocode = (country?.isocode || '').toUpperCase();
    this.form.get('country')?.get('isocode')?.setValue(isocode);
    this.country = country;
    this.cdr.detectChanges();
  }
}
